/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://bar57tsm3vbylm2fgkf46stj3e.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-south-1:9f8942d0-c4e1-4011-89ba-6f039c14d36b",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_mwHaiXNMg",
    "aws_user_pools_web_client_id": "484ktbm03drfg2so8k6p1br884",
    "oauth": {
        domain: "denali-devind.auth.ap-south-1.amazoncognito.com",
        scope: ["openid", "profile", "aws.cognito.signin.user.admin"],
        redirectSignIn: window.location.origin,
        redirectSignOut: `https://corpextdev.b2clogin.com/corpextdev.onmicrosoft.com/B2C_1A_OIDC_USERINFO_DENALI/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
        responseType: "code",
        client_id: "522f643d-5757-4085-b88d-c23004a8f0dd" //TODO: we need a production client id for federation
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "denali-analytics-validation-storage30655-devind",
    "aws_user_files_s3_bucket_region": "ap-south-1",
    appEnvironment: {
        BUILD_ENV: "devind",
        externalLinks: {
        traneConnectBaseURL: "https://stg.connect.tis.tranetechnologies.in",
        commandCenterBaseURL: "https://stg.tcc.tis.tranetechnologies.in",
        commandCenterGen4BaseURL: "https://gen4.tcc.tis-staging.trane.com/"
        }
    },
    "predictions": {
        "convert": {
            "translateText": {
                "region": "ap-south-1",
                "proxy": false,
                "defaults": {
                    "sourceLanguage": "en",
                    "targetLanguage": "fr"
                }
            }
        }
    },
    "geo": {
        "amazon_location_service": {
            "region": "ap-south-1",
            "search_indices": {
                "items": [
                    "denalilocator-devind"
                ],
                "default": "denalilocator-devind"
            },
            "maps": {
                "items": {
                    "denalimap-devind": {
                        "style": "VectorEsriNavigation"
                    }
                },
                "default": "denalimap-devind"
            }
        }
    }
};


export const amplitudeKey = "" //"925b71c693f419dc6c4c465b6e9b162f"
export default awsmobile
export const signOutUrl = `https://${awsmobile.oauth.domain}/logout?client_id=${awsmobile.aws_user_pools_web_client_id}&logout_uri=${awsmobile.oauth.redirectSignOut}&redirect_uri=${window.location.origin}&response_type=code`
export const APP_ID = "9b308188-33ad-4a84-8974-a412dc03e3f6"
export const remoteAccessURL = 'https://dev.api.tis.trane.com/remoteaccess/connect'
export const openVPNURL = 'https://api.tis-dev.trane.com/open-vpn-api/v2/remote'
export const staticFilesPath = "https://denali-staticfiles-obhtzgxdrvgv5nozqjammf4pk4-devind-ap-south-1.s3.amazonaws.com"
export const zendeskWidgetKey = "f42546cb-115b-4d5d-bf44-b4ddab8f10cd"

export const REACT_APP_API_ENDPOINT =
  "https://g9v0inu094.execute-api.us-east-1.amazonaws.com/dev/generate"
export const llmClientId = "pD6dOZoWO92F3MG0LIh5n8YtpivrdeIn7XWrc4Bw"

export const aiChatWebSocketURL="wss://abl1nrqawe.execute-api.ap-south-1.amazonaws.com/devind/"